import { render, staticRenderFns } from "./AddItemsModal.vue?vue&type=template&id=553c6999&scoped=true&"
import script from "./AddItemsModal.vue?vue&type=script&lang=ts&"
export * from "./AddItemsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddItemsModal.vue?vue&type=style&index=0&id=553c6999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c6999",
  null
  
)

export default component.exports